import { createContext, useContext } from 'react'

export type Language = 'en' | 'fr'

export const LanguageContext = createContext<Language>('fr')

export const useLanguage = () => useContext(LanguageContext)
